<template>
  <div
    class="newHeight"
    :class="{
      'h-100': !(
        Object.keys(searchResults).length === 0 &&
        searchResults.constructor === Object
      )
    }"
  >
    <transition name="drop">

      <searchbar-vue v-if="displaySearch && specificLink != 'EMAIL' && specificLink != 'CHAT'" :hide-search="hideSearch" />
      <portal-email-searchbar-vue v-if="displaySearch && specificLink == 'EMAIL'" :hide-search="hideSearch" />
      <chat-searchbar-vue v-if="displaySearch && specificLink == 'CHAT'" :hide-search="hideSearch" />
    </transition>
    <div class="calc-continer no-bor">
      <!-- Other links -->
      <div
        class="float-left header-icon left-wrapper extra-margin icons-left"
        v-if="!backButton || !backButton.show"
      >
        <div class="float-left home-split first">
          <!--<router-link to="/chat_dashboard" class="d-block" v-if="specificLink === 'CHAT'">-->
          <router-link to="/daily" class="d-block" v-if="specificLink === 'CHAT'">
            <img
              class="search-icon"
              :src="chatActiveIcon"
              type="image/svg+xml"
            />
          </router-link>
          <router-link to="" @click.native="redirectToUnreadEmailRoute" class="d-block" v-if="specificLink === 'EMAIL'">
             <img
              class="search-icon"
              :src="emailActiveIcon"
              type="image/svg+xml"
            />
            <span class="email-notification-count" v-if="getUnreadMailIds.length > 0">{{getUnreadMailIds.length}}</span>
          </router-link>
          <router-link to="/chat_dashboard"  v-if="specificLink !== 'CHAT' && specificLink !== 'EMAIL'">
            <object
              class="search-icon"
              :data="chatIcon"
              type="image/svg+xml"
            ></object>
          </router-link>
          <router-link to="" @click.native="redirectToMailPage" v-if="specificLink !== 'CHAT' && specificLink !== 'EMAIL'" class="contacts-email">

            <img
              class="search-icon"
              :src="emailIcon"
              type="image/svg+xml"
            />
            <span class="email-notification-count" v-if="unreadMailCountOnOtherPage">{{unreadMailCountOnOtherPage}}</span>
          </router-link>
        </div>
        <!-- <div
          v-if="userRole !== 22 && userRole !== 25"
          class="float-left call-icon"
        >
          <router-link to="/phone" class="d-block">
            <img :src="phoneActiveIcon" v-if="specificLink === 'PHONE'" />
            <img :src="phoneIcon" v-else />
          </router-link>
        </div> -->
      </div>

      <!-- Back button -->
      <div class="float-left header-icon left-wrapper extra-margin" v-else>

        <!-- For MailDetail Route only -->
        <div class="float-left home-split first" v-if="specificLink === 'MailDetail'">
          <a class="d-block" @click.prevent="backButton.action">
            <object
                    class="search-icon icon-back"
                    :data="backSvg"
                    type="image/svg+xml"
            ></object>
          </a>
        </div>

        <div class="float-left home-split first" v-else>
          <a class="d-block" @click.prevent="backButton.action">
            <object
              class="search-icon icon-back"
              :data="backSvg"
              type="image/svg+xml"
            ></object>
          </a>
        </div>
      </div>
      <!-- year wrapper-->
      <div class="year-wrapper" v-if="specificLink === 'EMAIL'">
        <span :class="{ plain: specificLink !== 'APPOINTMENT' }">{{
          heading
        }}</span>
      </div>
      <div class="year-wrapper" v-else>
        <span :class="{ plain: specificLink !== 'APPOINTMENT' }">{{
          heading
        }}</span>
      </div>
      <!-- year wrapper - Excluded for the MailDetail route -->
      <div :class="{'float-right header-icon-contain': true, 'inner-cons-rhs': checkEmailRoute}" v-if="specificLink !== 'MailDetail'">
        <split-icon-vue
          :click="showSplitScreen"
          v-if="
            !(
              specificLink === 'PHONE' ||
              specificLink === 'CHAT' ||
              specificLink === 'CLIENTS' ||
              specificLink === 'OTHERS'
            )
          "
        />
        <searc-icon-vue :click-stop-prevent="showSearch" />
        <favourite-icon-vue
          v-if="
            userRole !== 22 &&
              userRole !== 25 &&
              (specificLink === 'PHONE' ||
                specificLink === 'CHAT' ||
                specificLink === 'CLIENTS' ||
                specificLink === 'OTHERS')
          "
        />
        <!--<favourite-email-icon-vue
          v-if="specificLink === 'EMAIL'"
        />-->
        <compose-email-icon-vue
                v-if="specificLink === 'EMAIL'"
        />
        <add-icon-vue v-if="specificLink === 'APPOINTMENT'" />
        <add-client-icon v-if="specificLink === 'CLIENTS'" />
        <add-others-icon
          v-if="specificLink === 'OTHERS'"
          :show-add="additional.showAdd"
          :click="additional.click"
        />
        <add-chat-icon
          v-if="specificLink === 'CHAT'"
          :click="additional.click"
        />
      </div>
    </div>
  </div>
</template>

<script>
import AddChatIcon from "./AddChatIcon";
import FavouriteIconVue from "./FavouriteIcon";
import FavouriteEmailIconVue from "./FavouriteEmailIcon";
import ComposeEmailIconVue from "./ComposeEmailIcon";
import SplitIconVue from "../Appointment/common/SplitIcon.vue";
import AddIconVue from "../Appointment/common/AddIcon";
import SearcIconVue from "../Appointment/common/SearchIcon";
import SearchbarVue from "../Appointment/common/Searchbar.vue";
import PortalEmailSearchbarVue from "../Appointment/common/PortalEmailSearchbar.vue";
import ChatSearchbarVue from "../Appointment/common/ChatSearchbar";
import AddClientIcon from "./AddClientIcon";
import AddOthersIcon from "./AddOthersIcon";
import { permissionMixin } from "@/mixins/permissionMixin";
import { mapGetters, mapMutations, mapActions } from "vuex";

export default {
  mixins: [permissionMixin],
  data() {
    return {
      chatIcon: require("../../assets/svg/chat-bg-fill.svg"),
      chatActiveIcon: require("../../assets/img/m_chat-active.png"),
      emailActiveIcon: require("../../assets/img/m_email-active.png"),
      emailIcon: require("../../assets/img/m_email.png"),
      phoneIcon: require("../../assets/img/phone_26x26.png"),
      phoneActiveIcon: require("../../assets/img/m_phone-active.png"),
      backSvg: require("../../assets/svg/back.svg"),
      displaySearch: false
    };
  },
  props: {
    heading: [Number, String],
    specificLink: String,
    additional: {
      type: [Object, Boolean],
      default: false
    },
    backButton: {
      type: [Object, Boolean],
      default: false
    }
  },
  computed: {
    ...mapGetters({
      showResultsNow: "getShowResultsNow",
      searchResults: "getSearchResults"
    }),
    ...mapGetters("portalemail", {
      selectedUserId: "getSelectedUserId",
      subscriberId: "getSubscriberId",
      getUnreadMailIds: "getUnreadMailIds",
      unreadMailCountOnOtherPage: "getUnreadMailCountOnOtherPage"
    }),
    checkEmailRoute() {
      return ((this.$router.currentRoute.name === 'EmailDashboard') || (this.$router.currentRoute.name === 'EmailDetail'));
    }
  },
  components: {
    AddIconVue,
    SearcIconVue,
    SplitIconVue,
    SearchbarVue,
    PortalEmailSearchbarVue,
    AddClientIcon,
    FavouriteIconVue,
    FavouriteEmailIconVue,
    AddOthersIcon,
    AddChatIcon,
    ComposeEmailIconVue,
    ChatSearchbarVue
  },
  methods: {
    ...mapMutations({
      setDayOfMonth: "setDayOfMonth",
      setMonth: "setMonth",
      setYear: "setYear",
      setWeek: "setWeek",
      openShowSplitScreenMonthly: "openShowSplitScreenMonthly"
    }),
    ...mapMutations("portalemail", {
      resetStateForOtherUser: "resetStateForOtherUser",
      setSelectedUserId: "setSelectedUserId"
    }),
    goToDaily() {
      const today = new Date();
      this.setDayOfMonth(today.getDate());
      this.setWeek(today.getDate());
      this.setMonth(today.getMonth());
      this.setYear(today.getFullYear());
      this.$router.push("/daily");
    },
    showSplitScreen() {
      this.openShowSplitScreenMonthly();
      this.goToDaily();
    },
    showSearch() {
      this.displaySearch = true;
      this.setToAddPersonMode();
      this.$emit("search-displayed");
    },
    hideSearch() {
      this.displaySearch = false;
      this.$emit("search-hidden");
    },
    ...mapActions("person", {
      setToAddPersonMode: "setToAddPersonMode" // Search value in the search bar
    }),
    redirectToUnreadEmailRoute() {
      /*if(this.$route.params.type !== 'unread') {
        this.$parent.$parent.clearEditState();
        this.$router.push({name: 'EmailDashboard', params: {type: 'unread'}});
      }*/
      this.$router.push({name: 'Daily'});
    },
    redirectToMailPage() {
      if((this.subscriberId === 0) && (this.selectedUserId > 0)) {
        this.resetStateForOtherUser();
        this.setSelectedUserId(0);
      }
      this.$router.push("/emails/unread");
    }
  },
  created() {
    setTimeout(() => {
      if (
        this.showResultsNow &&
        !(
          Object.keys(this.searchResults).length === 0 &&
          this.searchResults.constructor === Object
        )
      ) {
        this.displaySearch = true;
        this.$emit("search-displayed");
      }
    });
  }
};
</script>

<style scoped>
.plain {
  font-weight: 300;
  font-size: 20px;
  color: #000;
}

.header-menu-contain {
  position: relative;
}

.sticky-header {
  height: 97px !important;
}

.header-icon-contain {
  top: 0 !important;
}

.left-wrapper {
  position: relative;
  left: 0px;
  top: 5px;
  width: 100%;
  max-width: 75px;
}

.today-wrapper {
  position: relative;
  margin-top: 2px;
  margin-left: 50px;
  margin-right: 30px;
  font-weight: bold;
}
/* year wrapper css here */
.year-wrapper {
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  color: #d26d13;
  text-align: center;
  line-height: 24px;
  width: calc(100% - 190px);
  left: 75px;
  float: left;
}
.year-wrapper span {
  position: relative;
  cursor: pointer;
}
/* year wrapper css ends here */

span.online {
  position: relative;
  width: 100px;
  height: 100px;
  background-color: lightgreen;
}

/*--.header-icon-contain .search-box-open,
.split-icon {
  margin-right: 10px;
}--*/
.call-icon {
  margin-left: 5px;
}
.newHeight {
  clear: both;
}
.router-link-active{
  position:relative;
}
.email-notification-count{
  font-size:11px;
  text-align:center;
  position:absolute;
  top:2px;
  right:-4px;
  display:flex;
  justify-content: center;
  align-items: center;
  color:#d26d13;
}
.contacts-email{
  position: relative;
}
.contacts-email img{
  width:26px;
  }
.contacts-email .email-notification-count{
  top:-4px;
}
.router-link-exact-active .email-notification-count{
  right:-7px;
  }
@media screen and (max-width: 480px) {
  .year-wrapper span {
    display: block;
    margin: 0 auto;
    text-align: center;
  }
}
</style>
